'use client'

import type { PropsWithChildren } from 'react'
import { Check, Clipboard } from 'lucide-react'
import { useClipboard } from '@/shared/hooks/useClipboard'
import Icon from '../Icon'

export type ClipboardButtonIconProps = {
    textToCopy: string
    className?: string
}

const ClipboardButtonIcon = ({ textToCopy, className = '' }: PropsWithChildren<ClipboardButtonIconProps>) => {
    const { copyStatus, onSetCopyStatus } = useClipboard()

    const onCopyToClipboard = () => {
        onSetCopyStatus(textToCopy)
    }

    return (
        <button
            type="button"
            data-testid="__clipboard-button__"
            onClick={onCopyToClipboard}
            className={`flex items-center gap-1 ${className}`}
        >
            {copyStatus === 'inactive' ? <Icon icon={Clipboard} /> : null}
            {copyStatus === 'copied' ? <Icon icon={Check} /> : null}
        </button>
    )
}

export default ClipboardButtonIcon
